import { gql } from 'apollo-angular';

export const getMyPermissionsQuery = gql`
    query MsEntraIdGetMyPermissions {
        msEntraIdGetMyPermissions {
            permissions
        }
    }
`;
